import { Requirement } from '../../types/data';
import Question from '../question/question';
import AddAction from '../add-action/add-action';
import AddComment from '../add-comment/add-comment';
import { calculatesAverageValue } from '../../utils/utils';
import { AdditionalInformation } from '../../types/data';
import { circle } from 'src/pages/DashboardPage/vpo/ui-icons/icons';
import { focusIcon } from '../../ui-icons/FocusGop';
import { Quarter } from '../../types/data';
import { PlanActionsContext } from '../../types/types';
import { MarkdownHooks } from 'react-markdown';
import { TooltipItem } from 'src/utils/Tooltip';
import { useAppSelector } from 'src/hooks/redux';
import { getDataMain } from '../../store/data-main/selectors';
import { useMemo } from 'react';

const COLUMNS = {
  '1': {
    width: '600px',
    indent: '0',
  },
};

type RowProps = Requirement & {
  factory: number;
  quarter: Quarter;
  year: number;
  group?: number;
  direction?: number;
  gopId?: number;
  isNotEditQuestionnaire?: boolean;
  onOpenModal?: (data?: AdditionalInformation) => void;
  onCreateQuestionnaire?: () => void;
  context?: PlanActionsContext;
};

function Row(props: RowProps) {
  const {
    title,
    requirementId,
    answers,
    isFocal,
    documentation,
    actions,
    comments,
    factory,
    quarter,
    year,
    group,
    direction,
    gopId,
    isNotEditQuestionnaire,
    onOpenModal,
    onCreateQuestionnaire,
    context,
  } = props;

  const storeData = useAppSelector(getDataMain);

  //!Коменты для обновления в add-comment
  const actualComments = useMemo(() => {
    if (!storeData?.data) {
      return comments;
    }
    for (const block of storeData.data) {
      for (const requirement of block.groupRequirements) {
        if (requirement.requirementId === requirementId) {
          const foundComments = requirement.answers[0]?.comments || null;
          return foundComments;
        }
      }
    }
    return comments;
  }, [storeData, requirementId, comments]);

  //!Действия для обновления в add-action
  const actualActions = useMemo(() => {
    if (!storeData?.data) {
      return actions;
    }
    for (const block of storeData.data) {
      for (const requirement of block.groupRequirements) {
        if (requirement.requirementId === requirementId) {
          return requirement.actions;
        }
      }
    }
    return actions;
  }, [storeData, requirementId, actions]);

  return (
    <tr>
      <td
        className='sticky z-10 border border-gray-400 bg-white px-2.5 py-2 text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400'
        style={{
          left: COLUMNS['1'].indent,
          width: `${COLUMNS['1'].width}`,
        }}
      >
        <div className='flex justify-between items-center gap-2'>
          <div className='wysiwyg'>
            <MarkdownHooks>{title}</MarkdownHooks>
          </div>

          {isFocal && (
            <span className='ml-auto'>
              <TooltipItem position='left' tooltipsText={'Фокусный GOP'}>
                {focusIcon}
              </TooltipItem>
            </span>
          )}

          {documentation && (
            <div className='flex-shrink-0 cursor-pointer' onClick={documentation ? () => onOpenModal?.(documentation) : undefined}>
              <TooltipItem position='left' tooltipsText={'Документация'}>
                {circle}
              </TooltipItem>
            </div>
          )}
        </div>
      </td>

      {answers.map((el, index) => (
        <td key={index} className='border border-gray-400 px-2.5 py-2 text-center text-xs'>
          <Question
            data={el}
            requirementTitle={title}
            requirementId={requirementId}
            factory={factory}
            quarter={quarter}
            year={year}
            group={group}
            direction={direction}
            gopId={gopId}
            isCompleted={isNotEditQuestionnaire as boolean}
            onCreateQuestionnaire={onCreateQuestionnaire}
          />
        </td>
      ))}

      <td className='border border-gray-400 px-2.5 py-2 text-center text-xs'>
        {calculatesAverageValue(answers)}
        {calculatesAverageValue(answers) !== 'N/A' && '%'}
      </td>
      <td className='border border-gray-400 px-2.5 py-2 text-center text-xs'>
        <div className='flex justify-center'>
          <AddAction actions={actualActions} context={context} />
        </div>
      </td>
      <td className='border border-gray-400 px-2.5 py-2 text-center text-xs'>
        <div className='flex justify-center'>
          <AddComment comments={actualComments} context={context} />
        </div>
      </td>
    </tr>
  );
}

export default Row;
